import React, { FC, ReactNode, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { ECharts } from 'echarts';
import { isPresent } from '@farmai-shared/LFUtils';
export const LegendItem: FC<{
  data: {
    label: string;
    svg: ReactNode;
    extra?: ReactNode;
  };
  event?: (e) => void;
  disabled: boolean | undefined;
}> = observer(({
  data,
  disabled,
  event
}) => {
  const {
    t
  } = useTranslation();
  const onClick = () => {
    if (event) event(data.label);
  };
  return <div className={`
        flex flex-row gap-x-4
        ${disabled ? 'opacity-50' : ''}
        items-center
      `}>
      <div onClick={onClick} className={`
          flex
          ${isPresent(onClick) ? 'cursor-pointer' : ''}
        `}>
        <svg width={24} height={16}>
          {data.svg}
        </svg>
        <p className="text-base font-light">{t(data.label)}</p>
      </div>
      {data.extra}
    </div>;
});
export const Legend: FC<{
  data: {
    label: string;
    svg: ReactNode;
  }[];
  className?: string;
  chartInstance?: ECharts | null;
  event?: (chartInstance: ECharts | null, label: string) => void;
  groupedLabels?: string[][];
}> = observer(({
  data,
  event,
  chartInstance,
  groupedLabels,
  className = 'flex gap-x-12 px-8 w-full flex-wrap gap-y-4 md:items-center md:flex-row md:justify-center'
}) => {
  const [disabledLegends, setDisabledLegends] = useState<Set<string>>(new Set());
  const handleLegendClick = (label: string) => {
    if (!chartInstance) return;
    setDisabledLegends(prevDisabledLegends => {
      const newDisabledLegends = new Set(prevDisabledLegends);
      const group = groupedLabels?.find(group => group.includes(label));
      if (group) {
        const isGroupDisabled = group.every(groupedLabel => newDisabledLegends.has(groupedLabel));
        group.forEach(groupedLabel => {
          isGroupDisabled ? newDisabledLegends.delete(groupedLabel) : newDisabledLegends.add(groupedLabel);
        });
      } else {
        newDisabledLegends.has(label) ? newDisabledLegends.delete(label) : newDisabledLegends.add(label);
      }
      return newDisabledLegends;
    });
    if (event) event(chartInstance, label);
  };
  return <div className={className}>
        {data.map(d => <LegendItem key={d.label} data={d} event={handleLegendClick} disabled={disabledLegends?.has(d.label)} />)}
      </div>;
});